import { sendLocal } from "../channels";
import { trackEvent } from "../messages/track-event";
export var sendTrackEvent = function sendTrackEvent(event) {
  return sendLocal(trackEvent(event));
};